<script lang="ts">
    import type {TocItem} from "../types/types";
    import {onMount} from "svelte";

    export let items: TocItem[];

    let timer: number;
    let active = '';
    let headerElements = items.map(item => item.element)

    const debounce = (cb: Function) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            cb()
        }, 150);
    }

    const determineActiveItem = () => {
        active = headerElements[0].id;

        for (let i = 0; i < headerElements.length; i++) {
            let top = headerElements[i].getBoundingClientRect().top;

            if (top < 255) {
                active = headerElements[i].id;
            }
        }
    }
    onMount(() => {
        window.addEventListener('scroll', () => {
            debounce(determineActiveItem);
        });
        determineActiveItem();
    })

</script>

<nav class="ac-toc">
	<ul class="ac-toc-list tac:list-none tac:p-0">
		{#each items as item}
			<li class="ac-toc-list__item" class:-active={active===item.id}>
				<a href="#{item.id}">{item.title}</a>
			</li>
		{/each}
	</ul>
</nav>